import { render, staticRenderFns } from "./menulists.vue?vue&type=template&id=69997f5c"
import script from "./menulists.vue?vue&type=script&lang=js"
export * from "./menulists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports